import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { Pagination, TableFooter } from "@windmill/react-ui";
import Review from "./Review";
import useFilter from "@hooks/useFilter";

const parpageElement = 2;
export default function PaginateReview({ review }) {
  const { dataTable, handleChangePage } = useFilter(review, parpageElement);

  return (
    <>
      <Review data={dataTable} />
      <TableFooter className="bg-gray-900 my-3 rounded-md">
        <Pagination
          totalResults={review?.length}
          resultsPerPage={parpageElement}
          onChange={(p) => {
            handleChangePage(p);
          }}
          label="Table navigation"
        />
      </TableFooter>
    </>
  );
}
